import request from '@/utils/request'
import { encrypt } from '@/utils/rsaEncrypt'

export function add(data) {
  return request({
    url: 'admin-auth/api/users',
    method: 'post',
    data
  })
}

export function del(ids) {
  return request({
    url: 'admin-auth/api/users',
    method: 'delete',
    data: ids
  })
}

export function edit(data) {
  return request({
    url: 'admin-auth/api/users',
    method: 'put',
    data
  })
}

export function editUser(data) {
  return request({
    url: 'admin-auth/api/users/center',
    method: 'put',
    data
  })
}

export function updatePass(user) {
  const data = {
    oldPass: encrypt(user.oldPass),
    newPass: encrypt(user.newPass)
  }
  return request({
    url: 'admin-auth/api/users/updatePass/',
    method: 'post',
    data
  })
}

export function updateEmail(form) {
  const data = {
    password: encrypt(form.pass),
    email: form.email
  }
  return request({
    url: 'admin-auth/api/users/updateEmail/' + form.code,
    method: 'post',
    data
  })
}

export function projeckOrg(data) { 
  return request({
    url: 'admin-auth/api/project/org',
    method: 'get',
    params:data
  })
}
export function projectAll(data) { 
  return request({
    url: 'admin-auth/api/project/all',
    method: 'get',
    params:data
  })
}

export function versions() {
  return request({
      url: 'admin-auth/api/menus/versions',
      method: 'get',
  })
}

export function grant(data) { 
  return request({
    url: 'admin-auth/api/users/grant',
    method: 'post',
    data
  })
}

export function getUsers(data) {
  return request({
    url: 'admin-auth/api/users',
    method: 'get',
    params: data
  })
}
export function deleteUserRole(data) {
  return request({
    url: 'admin-auth/api/users/deleteUserRole',
    method: 'post',
    data
  })
}

export function deptUserTree(data) {
  return request({
    url: 'admin-auth/api/dept/dept-user-tree',
    method: 'get',
    params: data
  })
}

export default { add, edit, del, getUsers, deleteUserRole }

